class HolsterDrawer extends DrawerElement {
  connectedCallback() {
    super.connectedCallback();
    
    document.addEventListener("holster:available", (e) => {
      const { holsterId, url } = e.detail;
      if (this.dataset.holsterKey === holsterId) {
        // Light DOM updaten — wird bei _syncContent() korrekt geklont
        const link = this.querySelector(".drawer-holster-link");
        if (link) {
          link.href = url;
          // Panel-Klon auch sofort aktualisieren falls Drawer offen ist
          const panelLink = this._body?.querySelector(".drawer-holster-link");
          if (panelLink) panelLink.href = url;
        }
      }
    });
  }
}

customElements.define("holster-drawer", HolsterDrawer);